<template>
  <div class="scrollable-content--width">
    <section>
      <div class="section-hraph">
        <div class="section-hraph-data">
          <div class="section-graph-header-wrap">
            <div class="common-label">Compensation Data</div>
            <div class="light-label">
              Compensation / Percent of participants
            </div>
          </div>

          <div class="section-ghraph-data-content">
            <div class="section-ghraph-data-content-row">
              <roe-compensation-segment-bar
                range="$0 - $10K"
              ></roe-compensation-segment-bar>
              <roe-compensation-segment-bar
                range="$130K - $140K"
              ></roe-compensation-segment-bar>
            </div>

            <div class="section-ghraph-data-content-row">
              <roe-compensation-segment-bar
                range="$10K - $20K"
              ></roe-compensation-segment-bar>
              <roe-compensation-segment-bar
                range="$140K - $150K"
              ></roe-compensation-segment-bar>
            </div>

            <div class="section-ghraph-data-content-row">
              <roe-compensation-segment-bar
                range="$20K - $30K"
              ></roe-compensation-segment-bar>
              <roe-compensation-segment-bar
                range="$150K - $160K"
              ></roe-compensation-segment-bar>
            </div>

            <div class="section-ghraph-data-content-row">
              <roe-compensation-segment-bar
                range="$30K - $40K"
              ></roe-compensation-segment-bar>
              <roe-compensation-segment-bar
                range="$160K - $170K"
              ></roe-compensation-segment-bar>
            </div>

            <div class="section-ghraph-data-content-row">
              <roe-compensation-segment-bar
                range="$40K - $50K"
              ></roe-compensation-segment-bar>
              <roe-compensation-segment-bar
                range="$170K - $180K"
              ></roe-compensation-segment-bar>
            </div>

            <div class="section-ghraph-data-content-row">
              <roe-compensation-segment-bar
                range="$50K - $60K"
              ></roe-compensation-segment-bar>
              <roe-compensation-segment-bar
                range="$180K - $190K"
              ></roe-compensation-segment-bar>
            </div>

            <div class="section-ghraph-data-content-row">
              <roe-compensation-segment-bar
                range="$60K - $70K"
              ></roe-compensation-segment-bar>
              <roe-compensation-segment-bar
                range="$190K - $200K"
              ></roe-compensation-segment-bar>
            </div>

            <div class="section-ghraph-data-content-row">
              <roe-compensation-segment-bar
                range="$70K - $80K"
              ></roe-compensation-segment-bar>
              <roe-compensation-segment-bar
                range="$200K - $210K"
              ></roe-compensation-segment-bar>
            </div>

            <div class="section-ghraph-data-content-row">
              <roe-compensation-segment-bar
                range="$80K - $90K"
              ></roe-compensation-segment-bar>
              <roe-compensation-segment-bar
                range="$210K - $220K"
              ></roe-compensation-segment-bar>
            </div>

            <div class="section-ghraph-data-content-row">
              <roe-compensation-segment-bar
                range="$90K - $100K"
              ></roe-compensation-segment-bar>
              <roe-compensation-segment-bar
                range="$220K - $230K"
              ></roe-compensation-segment-bar>
            </div>

            <div class="section-ghraph-data-content-row">
              <roe-compensation-segment-bar
                range="$100K - $110K"
              ></roe-compensation-segment-bar>
              <roe-compensation-segment-bar
                range="$230K - $240K"
              ></roe-compensation-segment-bar>
            </div>

            <div class="section-ghraph-data-content-row">
              <roe-compensation-segment-bar
                range="$110K - $120K"
              ></roe-compensation-segment-bar>
              <roe-compensation-segment-bar
                range="$240K - $250K"
              ></roe-compensation-segment-bar>
            </div>

            <div class="section-ghraph-data-content-row">
              <roe-compensation-segment-bar
                range="$120K - $130K"
              ></roe-compensation-segment-bar>
              <roe-compensation-segment-bar
                range="> $250K"
              ></roe-compensation-segment-bar>
            </div>
          </div>
        </div>
        <div class="section-hraph-segments">
          <div class="section-graph-header-wrap">
            <div class="common-label">Compensation Segments</div>
          </div>

          <div class="section-graph-form-wrap">
            <div
              v-for="(compensation_segment,
              index) in originalPlan.compensation_segments"
              class="form-row"
            >
              <div class="form-unit">
                <div class="light-label">
                  Segment {{ +index + 1 }}
                  <template v-if="+index === 4">
                    (more than)</template
                  >
                </div>
              </div>
              <div class="form-unit">
                <roe-error-message
                  class="input-wrap--small"
                  :field="
                    $v.originalPlan.compensation_segments.$each[index].from
                  "
                >
                  <input
                    type="number"
                    v-model.number="compensation_segment.from"
                    :disabled="+index !== 0"
                    required
                    min="0"
                  />
                  <label class="input-label-inside">$</label>
                </roe-error-message>
                <template
                  v-if="
                    +index !== originalPlan.compensation_segments.length - 1
                  "
                >
                  <div class="input-devider">-</div>
                  <roe-error-message
                    class="input-wrap--small"
                    :field="
                      $v.originalPlan.compensation_segments.$each[index].to
                    "
                    :min-value="compensation_segment.from"
                  >
                    <input
                      type="number"
                      v-model.number="compensation_segment.to"
                      @input="changeCompensationToValue(+index)"
                      required
                      min="0"
                    />
                    <label class="input-label-inside">$</label>
                  </roe-error-message>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { required, minValue, requiredIf } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeCompensationSegmentBar from "@/components/charts/CompensationSegmentBar";

import { SET_INVALID_FORM_STATE } from "@/store/mutations.type";
import { FETCH_COMPENSATION_SEGMENTS } from "@/store/actions.type";
import { mapGetters } from "vuex";

import { helpers } from "vuelidate/lib/validators";
let minValueTo = function(minValue) {
  return helpers.withParams(
    {
      type: "minValue",
      min: minValue
    },
    function(value, object) {
      return (
        !helpers.req(value) ||
        ((!/\s/.test(value) || value instanceof Date) && +value > object.from)
      );
    }
  );
};

export default {
  name: "RoeBasicDataForm",
  mixins: [validationMixin],
  components: {
    RoeErrorMessage,
    RoeCompensationSegmentBar
  },
  mounted() {
    this.fetchCompensationSegments();
  },
  created() {
    this.$store.commit(SET_INVALID_FORM_STATE, { isInvalid: this.$v.$invalid });
  },
  watch: {
    "$v.$invalid": function(value) {
      this.$store.commit(SET_INVALID_FORM_STATE, { isInvalid: value });
    }
  },
  validations() {
    return {
      originalPlan: {
        compensation_segments: {
          required,
          $each: {
            from: { required, minValue: minValue(0), currency: true },
            to: {
              minValue: minValueTo(0),
              required: requiredIf(v => v.to !== null && v.to !== undefined),
              currency: true
            }
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters(["originalPlan"])
  },
  methods: {
    changeCompensationToValue(index) {
      this.originalPlan.compensation_segments[
        index + 1
      ].from = this.originalPlan.compensation_segments[index].to;
    },
    fetchCompensationSegments() {
      this.$store.dispatch(
        FETCH_COMPENSATION_SEGMENTS,
        this.$router.currentRoute.params.id
      );
    }
  }
};
</script>
